import React, { forwardRef, useEffect, useState } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { factory } from "../../api/apiFactory";

const educationDegreeApi = factory.get("other");

export const SelectEducationsDegree = forwardRef((props, ref) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [search, setSearch] = useState("");

  const fetchEducationDegreee = () => {
    setLoading(true);
    educationDegreeApi.indexEducationDegree().then((res) => {
      setOptions(res.data.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchEducationDegreee();
    }, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <Autocomplete
      ref={ref}
      options={options}
      {...props}
      getOptionLabel={(option) => `${option.name_en} - ${option.name_ar}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={!props.label ? "Education degree" : props.label}
          error={props.error ? props.error : null}
          helperText={props.helperText ? props.helperText : null}
          // onChange={(e, value) => {
          //   setSearch(e.target.value);
          // }}
          required={props.required}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
});
